import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { LocalStorage, LocalStorageService  } from 'ngx-store';
import { saveAs } from 'file-saver';
import { FormGroup, FormBuilder, Validators,FormArray } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ImageResult } from 'ngx-image2dataurl';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

//Service
import { ExportService } from '../../services/exporter.service';
import { NonComplianceService } from '../../services/non-compliance.service';
import { FilesService } from '../../services/files.service';
import { TaskService } from '../../services/tasks.service';

//Model
import { FileExport } from '../../model/exporter.model';
import { ThemeSetting,Url, User } from '../../model/users.model';
import { NonCompliance,Corrective_Action } from '../../model/non-compliance.model';
import { Task } from '../../model/tasks.model';
import { ComponentsSettingsService } from 'src/app/services/components_settings.service';

@Component({
  selector: 'app-qar',
  templateUrl: './qar.component.html',
  styleUrls: ['./qar.component.scss'],
  providers:[FilesService,TaskService],
  encapsulation: ViewEncapsulation.None,
})


export class QualityAssuranceReportComponent implements OnInit {
  public url: Url;
  @LocalStorage() user: User;
  public s_theme: ThemeSetting;
  public modalRef: NgbModalRef;
  public fileStoragePath:any;
  loadingIndicator: boolean = true;
  spinner: boolean = false;
  public fileExists :boolean;
  public oldFile: string;
  public frmFile: any;
  public fileRemove:boolean;
  isEditMode: boolean = false;
  isFilterEmpty: boolean = true;
  drivers = [];
  fleet = [];
  allCustomers = [];
  customer = [];
  temp = [];
  errorFromSubscribe;

  //Handles the name, type and content of the to-be exported file
  public exp_excel: FileExport;
  public exp_pdf: FileExport;
  
  //Stores the filtered and formatted content of the file
  formatted_list : any;

  //Tasks
  public task: Task;
  public tasksByCarId: Task[];
  task_title:any;

   //NCR
  ncr_columns = [
    { prop: 'id' },
    { prop: 'classification_name'},
    { prop: 'driver_id'},
    { prop: 'driver_name'},
    { prop: 'codename'},
    { prop: 'category_name'},
    { prop: 'status_name'},
    { prop: 'fleet_id'},    
    { prop: 'customer_id'},
    { prop: 'file'},
    { prop: 'problem_details'}
  ];

  breach_categories =[];
  breach_codes =[];
  breach_classification =[];
  breach_status =[];
 
  ncr_rows:any[];
  ncrCount: number = 0;
  fullRows=[];
  selected = [];
  sample:any;

  public NCR: NonCompliance;
  public readonly prefixNCR = 'ncr';

  showBreachCategory:boolean=true;
  showCode:boolean=true;
  showClassification:boolean=true;
  showStatus:boolean=true;
  showFleet:boolean =true;
  showCustomer:boolean = true;
  showDriver:boolean=true;
  showProblemDetails:boolean=true;
  showFile: boolean=true;

  public NCRForm: FormGroup;
  public showSidebar : boolean = true;
  showFilters: boolean = false;

  //CAR
  car_categories =[];
  car_codes =[];
  car_classification =[];
  car_status =[];
  car_corrective_action =[];
  users = [];
  ca_distribution_list = [];

  fullCarRows=[];
 
  public CAR: Corrective_Action;
  public readonly prefixCAR = 'ca_report';

  filterStatus: string = '';
  filterBreachCategory: string = '';
  filterBreachCode: string = '';
  filterBreachClass: string = '';
  filterBreachStat: string = '';
  filterNcrDriver: string = '';
  filterCorrectiveAction: string = '';
  filterRaisingPerson: string = '';
  filterPersonInvolved: string = '';
  filterShortFix: string = '';
  filterLongFix: string = '';
  filterCarDriver: string = '';

  showCarBreachCategory:boolean=false;
  showCarProblemDetails:boolean=true;
  showCarCode:boolean=false;
  showCarClassification:boolean=false;
  showCorrectiveCAR: boolean = true;
  showClassificationCAR: boolean = false;
  showStatusCAR: boolean = true;
  showRaisingPerson: boolean = true;
  showRaisingDate: boolean = true;
  showPersonInvolved: boolean = true;
  showPersonInvolvedDate: boolean = false;
  showDistributionList: boolean = true;
  showClosingOutDate: boolean = false;
  showShortTermFix: boolean = false;
  showFileCAR: boolean = true;
  showCarDriver: boolean = true;
  showShortCloseOutPerson: boolean = false;
  showShortCloseOutDate: boolean = false;
  showLongTermFix: boolean = false;
  showLongTermCloseOutPerson: boolean = false;
  showLongTermCloseOutDate: boolean = false;
  showManagerSignedDate: boolean = false;
  showApprovedBy: boolean = false;

  public CARForm: FormGroup;
  public showSidebar2 : boolean = true;
  showFilters2: boolean = false;
  carId:number;

  dateNow:any;

  car_columns = [
    { prop: 'id' },
    { prop: 'category_name'},
    { prop: 'classification_name'},
    { prop: 'codename'},
    { prop: 'status_name'},
    { prop: 'ca_name'},
    { prop: 'fleet_id'},
    { prop: 'driver_id'},
    { prop: 'driver_name'},
    { prop: 'customer_id'},
    { prop: 'to_management'},
    { prop: 'to_admin'},
    { prop: 'to_operations'},
    { prop: 'to_drivers'},
    { prop: 'to_others'},
    { prop: 'problem_details'},
    { prop: 'file'},
    { prop: 'close_out_date' },
    { prop: 'raising_person' },
    { prop: 'raising_date' },
    { prop: 'ca_short_term_fix'},
    { prop: 'ca_short_close_out_person_name'},
    { prop: 'ca_short_close_out_date'},
    { prop: 'ca_long_term_fix'},
    { prop: 'ca_long_close_out_person_name'},
    { prop: 'ca_long_close_out_date'},
    { prop: 'person_involved_name' },
    { prop: 'person_involved_signature'},
    { prop: 'person_involved_date_signed'},
    { prop: 'approved_name'},
    { prop: 'approved_date'},
    { prop: 'ncr_distribution_list' },
  ];

  car_rows:any[];
  sampleCar:any;
  selected4 = [];
  loadingIndicator2: boolean = true;
  carCount:number = 0;
  public objToDelete: any;
  dist_disp:any;
  dist_disp_length:any;
  ip:any;
  is_image: boolean= true;
  isDriverSelected: boolean = false;

  public pushFleetOptions: IMultiSelectOption[];
  public pushFleetModel= [];
  public pushFleetSettings: IMultiSelectSettings = {
      enableSearch: true,
      checkedStyle: 'fontawesome',
      buttonClasses: 'btn btn-sm btn-secondary btn-block',
      dynamicTitleMaxItems: 1,
      displayAllSelectedText: true,
      showCheckAll: true,
      showUncheckAll: true
  };

  public pushFleet: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    defaultTitle: 'Select Fleet',
    allSelected: 'All selected',
};


public pushDriverOptions: IMultiSelectOption[];
public pushDriverModel= [];
public pushDriverSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-sm btn-secondary btn-block',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true
};

public pushDriver: IMultiSelectTexts = {
  checkAll: 'Select all',
  uncheckAll: 'Unselect all',
  checked: 'item selected',
  checkedPlural: 'items selected',
  searchPlaceholder: 'Find',
  defaultTitle: 'Select Driver',
  allSelected: 'All selected',
};

  @ViewChild('modalNCR', { static: false }) modalNCR: TemplateRef<any>;
  @ViewChild('modalNCRDetails', { static: false }) modalNCRDetails: TemplateRef<any>;
  @ViewChild('modalCARDetails', { static: false }) modalCARDetails: TemplateRef<any>;
  @ViewChild('modalCAR', { static: false }) modalCAR: TemplateRef<any>;
  @ViewChild('modalCancel', { static: false}) modalCancel: TemplateRef<any>;
  @ViewChild('modalDelete', { static: false}) modalDelete: TemplateRef<any>;

  constructor( private exporter: ExportService,private ncrService: NonComplianceService,private http: HttpClient,private taskService: TaskService,
     private _fb: FormBuilder, private modal: NgbModal,private toastr: ToastrService, private fileService: FilesService, private svc_storage: LocalStorageService,   private svc_components : ComponentsSettingsService, ) { }

    ngOnInit(){
      this.dateNow = new Date().toLocaleString();
      this.s_theme = this.svc_storage.get('themeSettings');
      this.url = this.svc_storage.get('url');
      this.fileStoragePath= this.url.fileStorage;
      var res = [];
      this.http.get(this.url.rest + '/tms/getNCRMiscData')
      .subscribe((data) => {
        this.fleet = data["fleet"];
        this.fleet.forEach(fleet=>{
         var fl = {id:fleet.id, name: fleet.rego};
         res.push(fl);
     })
     
      this.pushFleetOptions = res;
      this.breach_categories = data['categories'];
      this.breach_codes= data['code'];
      this.breach_classification = data['classification'];
      this.breach_status = data['status'];
      this.drivers = data["drivers"];
      var dr_array = [];
      this.drivers.forEach(drv=>{
        var dr = {id:drv.id, name: drv.first_name+' '+drv.last_name};
        dr_array.push(dr);
       })
      this.pushDriverOptions = dr_array;
      this.allCustomers = data["customers"];
      this.customer = this.allCustomers;
      this.getNCR();
      
      }, error => {
        this.errorFromSubscribe = error;
      });

      this.http.get(this.url.rest + '/tms/getCarMiscData')
      .subscribe((data) => {

      this.car_categories = data['categories'];
      this.car_codes= data['code'];
      this.car_classification = data['classification'];
      this.car_status = data['status'];
      this.car_corrective_action = data['corrective_action'];
      this.users = data['users']
      this.ca_distribution_list = data['ca_distribution_list']
      
      this.getCar();
      }, error => {
        this.errorFromSubscribe = error;
      });

      this.exp_excel = {title:'', list_data:'', type:''};
      this.exp_pdf = {title:'', list_data:'', type:''};
    }

    public getNCR(){
      this.initNCRForm();
      this.loadingIndicator = true;
      this.ncrService.getNCRList().subscribe(result=>{
        this.ncr_rows = result['ncr'];
        this.sample = this.ncr_rows;

        this.temp = this.ncr_rows;
        this.fullRows = this.ncr_rows;
        this.ncrCount = Object.keys(this.ncr_rows).length;

        if (typeof this.ncr_rows != "undefined"  && this.ncr_rows != null  
        && this.ncr_rows.length != null  && this.ncr_rows.length > 0) {
          this.selected = [this.ncr_rows[0]];
         var rego = '';
          this.fleet.forEach(el => {
            let temp = JSON.parse(this.selected[0]['fleet_id'])?.find(x=> x == el.id);
              if(temp){
                  if(rego){
                    rego = el.rego
                    this.selected[0]['fleet'] =  this.selected[0]['fleet'] +','+rego;
                  }
                  else{
                    rego = el.rego
                    this.selected[0]['fleet'] = rego;
                  }
              }
          })
        }  
        else{
          this.selected=[];
        }
        setTimeout(() => { this.loadingIndicator = false; }, 500);
    }); 
    }

    public getCar(){
      this.initCarForm();
      this.loadingIndicator2 = true;
      this.ncrService.getCARList().subscribe(result=>{
      this.sampleCar = result['car']
      this.car_rows = result['car'].map((car) => {
        let dist_list_display: string[] = [];
        if(car.to_management === 1) {
          dist_list_display.push('Management');
        }
        if(car.to_admin === 1) {
          dist_list_display.push('Admin');
        }
        if(car.to_operations === 1) {
          dist_list_display.push('Operations');
        }
        if(car.to_drivers === 1) {
          dist_list_display.push('Drivers');
        }
        if(car.others === 1) {
          dist_list_display.push('Others');
        }
        this.dist_disp_length =  Object.keys(dist_list_display).length
        this.dist_disp = dist_list_display.join(', ')
        
        return { ...car, ncr_distribution_list: dist_list_display.join(', ') };
      });

      this.temp = this.car_rows;  
      this.fullCarRows = this.car_rows;
      this.carCount = Object.keys(this.car_rows).length;

      if (typeof this.car_rows != "undefined"  && this.car_rows != null  
      && this.car_rows.length != null  && this.car_rows.length > 0) {
        this.selected4 = [this.car_rows[0]];
      }  
      else{
        this.selected4=[];
      }
      this.getTasksByCarId();
      setTimeout(() => { this.loadingIndicator2 = false; }, 500);
    });
    }

    checkPushModel() {
      if (this.pushFleetModel) {
        if (this.pushFleetModel.length < 1)
          return false;
        else return true;
      }
      else return false;
     
    }

    checkDriverModel() {
        if (this.pushDriverModel) {
            if (this.pushDriverModel.length < 1){
              this.isDriverSelected = false;
              return false;
            }
            else { 
              this.isDriverSelected = true; return true; 
            }
        }
        else  this.isDriverSelected = false; return false;
    }
  
    toggleSideBar(){
      if(this.showSidebar== false){
        this.loadingIndicator = true;
        this.showSidebar = true;
        setTimeout(() => { this.loadingIndicator = false; }, 100);
      }else{
        this.loadingIndicator = true;
        this.showSidebar = false;
        setTimeout(() => { this.loadingIndicator = false; }, 100);
      }
      this.getNCR();
    }

    public toggleFilters() {
      if (this.showFilters) this.showFilters = false;
      else this.showFilters = true;
    }

    toggleSideBar2(){
      if(this.showSidebar2 == false){
        this.loadingIndicator2 = true;
        this.showSidebar2 = true;
        setTimeout(() => { this.loadingIndicator2 = false; }, 100);
      }else{
        this.loadingIndicator2 = true;
        this.showSidebar2 = false;
        setTimeout(() => { this.loadingIndicator2 = false; }, 100);
      }
      this.getCar();
    }

    public toggleFilters2() {
      if (this.showFilters2) this.showFilters2 = false;
      else this.showFilters2 = true;
    }

    initNCRForm() {
      this.NCRForm = this._fb.group({
        id:                   [''],
        category_id:          ['', Validators.required],
        code_id:              ['', Validators.required],
        classification_id:    ['', Validators.required],
        driver_id:            [],
        fleet_id:             [''],
        status_id:            [''],
        problem_details:      ['', Validators.required],
        customer_id:          [''],
        file:                 [''],
        supporting_docs:      [''],
        user_id:              [''],
        run_control_no:       ['']
    });
    }

    initCarForm() {

       this.CARForm = this._fb.group({
        id:                                     [''],
        breach_category_id:                     ['',Validators.required],
        code_id:                                ['',Validators.required],
        classification_id:                      ['',Validators.required],
        driver_id:                              [''],
        fleet_id:                               [],
        customer_id:                            [''],
        status_id:                              ['',Validators.required],
        problem_details:                        ['',Validators.required],
        closed_by:                              [''],
        close_out_date:                         [''],
        raising_person:                         [''],
        raising_date:                           ['',Validators.required],
        ca_id :                                 ['',Validators.required],
        ca_short_term_fix:                      [''],
        ca_short_close_out_person:              [''],
        ca_short_close_out_date:                [''],
        ca_long_term_fix  :                     [''],
        ca_long_close_out_person:               [''],
        ca_long_close_out_date:                 [''],
        person_involved_name :                  [''],
        person_involved_date_signed:            [''],
        file:                                   [''],
        ncr_id:                                 [''],
        approved_by:                            [''],
        approved_date:                          [''],
        run_control_no:                         [''],
        supporting_docs:                        [''],
        ca_distribution_list:                   this._fb.array([]),
      });
      
      this.setDistributionList();
    }

    setDistributionList() {
      const caDistributionArray = this.CARForm.get('ca_distribution_list') as FormArray;
      this.ca_distribution_list.forEach(ca => {
        const distributionGroup = this._fb.group({
            name: [ca.name],
            value: [ca.value],
            checked: [false]
        });
        caDistributionArray.push(distributionGroup);
      });
    }

    get caDistributionArray(){
      return (this.CARForm.controls.ca_distribution_list as FormArray)
    }
  
    getDistributionListGroup(index: number): FormGroup {
      return this.caDistributionArray.at(index) as FormGroup;
    }

    resetFormControl(type){
      if(type == 'car'){
        const pCtrl = (<any>this.CARForm);
        pCtrl.controls.customer_id.setValue('');
      }
      else{
        const pCtrl = (<any>this.NCRForm);
        pCtrl.controls.customer_id.setValue('');
      }
    }

    openNCRModal(NCR:NonCompliance): void {
      if(NCR){
        this.customer = this.allCustomers.filter(data => { return data.deleted_date == null || NCR.customer_id == data.id });
        this.isEditMode = true;
        this.pushFleetModel=[];
        this.pushDriverModel=[];
        this.fleet.forEach(el => {
          let temp = JSON.parse(NCR['fleet_id'])?.find(x=> x == el.id);
            if(temp){
                this.pushFleetModel.push(el.id)
            }
        })

        this.drivers.forEach(dr => {
          let drv = JSON.parse(NCR['driver_id'])?.find(y=> y == dr.id);
            if(drv){
                this.pushDriverModel.push(dr.id)
            }
        })
        
        if (NCR.supporting_docs != null && NCR.supporting_docs != '')
        {
          this.oldFile = NCR.supporting_docs;
          this.fileExists = true;
        }
        else{
          this.fileExists = false;
        }
        this.NCRForm.patchValue(NCR);
      }
      else{
        this.customer = this.allCustomers.filter(data => { return data.deleted_date == null });
        this.fileExists = false;
        this.isEditMode = false;
          this.NCR = new NonCompliance();
          this.NCRForm.reset();
      }
      this.modalRef = this.modal.open(this.modalNCR, { size: 'lg', backdrop: 'static'});
    }

    openNCRDetails(row): void {
      var rego = '';
      this.selected[0]= row;
      this.selected[0]['fleet'] ='';
      this.fleet.forEach(el => {
        let temp = JSON.parse(row['fleet_id'])?.find(x=> x == el.id);
          if(temp){
              if(rego){
                rego = el.rego
                this.selected[0]['fleet'] =  this.selected[0]['fleet'] +','+rego;
              }
              else{
                rego = el.rego
                this.selected[0]['fleet'] = rego;
              }
          }
      })
      this.modalRef = this.modal.open(this.modalNCRDetails, { size: 'lg', backdrop: 'static'});
    }

    openCARDetails(): void {
      this.modalRef = this.modal.open(this.modalCARDetails, { size: 'lg', backdrop: 'static'});
    }

    openCARModal(CAR:Corrective_Action,data): void {
      if(data == true){
        this.customer = this.allCustomers.filter(data => { return data.deleted_date == null || data.id == CAR.customer_id });
        this.isEditMode = true;
        this.pushFleetModel=[];
        this.pushDriverModel = [];
        this.fleet.forEach(el => {
          let temp = JSON.parse(CAR['fleet_id'])?.find(x=> x == el.id);
            if(temp){
                this.pushFleetModel.push(el.id)
            }
        })

        this.drivers.forEach(dr => {
          let drv = JSON.parse(CAR['driver_id'])?.find(y=> y == dr.id);
            if(drv){
                this.pushDriverModel.push(dr.id)
            }
        })

        if (CAR.supporting_docs != null && CAR.supporting_docs != '')
        {
          this.oldFile = CAR.supporting_docs;
          this.fileExists = true;
        }
        else{
          this.fileExists = false;
        }

        const caDistributionArray = this.CARForm.get('ca_distribution_list') as FormArray;

        caDistributionArray.clear();
    
        this.ca_distribution_list.forEach(ca => {
          const isChecked = this.getCheckStatus(ca.value, CAR);
          const distributionGroup = this._fb.group({
            name: [ca.name],
            value: [ca.value],
            checked: [isChecked] 
          });
      
          caDistributionArray.push(distributionGroup);
        });

        this.CARForm.patchValue(CAR);
        
      }
      else{
       
        this.customer = this.allCustomers.filter(data => { return data.deleted_date == null || data.id == CAR.customer_id});
        this.isEditMode = false;
        this.fileExists = false;
        this.CARForm.controls.fleet_id.setValue(CAR.fleet_id);
        this.CARForm.controls.customer_id.setValue(CAR.customer_id);
        this.CARForm.controls.ncr_id.setValue(CAR.id);
        this.CARForm.controls.problem_details.setValue(CAR.problem_details);
        this.CARForm.controls.run_control_no.setValue(CAR.run_control_no);
        this.CARForm.controls.breach_category_id.patchValue(CAR['category_id']);
        this.CARForm.controls.classification_id.patchValue(CAR['classification_id']);
        this.CARForm.controls.code_id.patchValue(CAR['code_id']);
        this.CARForm.controls.status_id.patchValue(CAR['status_id']);

        this.pushFleetModel=[];
        this.fleet.forEach(el => {
          let temp = JSON.parse(CAR['fleet_id'])?.find(x=> x == el.id);
            if(temp){
                this.pushFleetModel.push(el.id)
            }
        })

        this.pushDriverModel = [];
        this.drivers.forEach(dr => {
          let drv = JSON.parse(CAR['driver_id'])?.find(y=> y == dr.id);
            if(drv){
                this.pushDriverModel.push(dr.id)
            }
        })
      }
      this.modalRef = this.modal.open(this.modalCAR, { size: 'lg', backdrop: 'static'});
    }

    getCheckStatus(distributionValue: string, CAR: any): boolean {
      return CAR[distributionValue] === 1;
    }

    public openModalCancel(car:Corrective_Action){
      this.objToDelete = car.id
      this.modalRef = this.modal.open(this.modalCancel, {container: '.app', backdrop: 'static'});

    }

    public openModalDelete(ncr: NonCompliance){
      this.objToDelete = ncr.id
      this.modalRef = this.modal.open(this.modalDelete, {container: '.app', backdrop: 'static'});
    }

    public closeModal(){
      this.modalRef.close();
      this.initNCRForm();
      this.initCarForm();
      this.pushFleetModel = [];
      this.pushDriverModel = [];
      this.isDriverSelected = false;
    }

    getCellClass({ row, column, value }): any {
      return {
        'is-pending': row.status_name == 'Pending',
        'is-processing': row.status_name == 'Processing',
        'is-completed': row.status_name == 'Resolved',
        'is-cancelled': row.status_name== 'Cancelled',
        'is-dispatched': row.status_name== 'Terminated',
      };
    }

    //Returns a date format in the file name
    public formattedDate(d = new Date) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return `${day}/${month}/${year}`;
    }

    //Create,Update and Delete functionalities for NCR
    async onSubmitNCR(NCR: any) {
      NCR.fleet_id = this.pushFleetModel;
      NCR.driver_id = this.pushDriverModel;
      NCR.user_id = this.user.id
      this.spinner = true;
      NCR.frmFile = this.frmFile;
      if(this.frmFile){
          await this.uploadFile(this.prefixNCR, NCR.supporting_docs);
      }
      if(NCR.id){
        await this.ncrService.updateNCR(NCR).toPromise().then(result=> {
          this.toastr.success('', result['message'], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
          }); 
              
      }).catch(err =>{
          this.toastr.error("Please try again.", "There was a problem with updating the selected ncr entry.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).finally(() => {
          
        });
      }
      else{ 
        NCR.status_id = 1;
      await this.ncrService.createNCR(NCR).toPromise().then(result => {
              this.toastr.success('', result['message'], {
                  timeOut: 5000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                });
              
      }).catch(err =>{
              this.toastr.error("Please try again.", "There was a problem with creating new ncr entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
              });
          }).finally(() => {
              
          });
      }
      this.pushFleetModel = [];
      this.pushDriverModel = [];
      this.getNCR();  
      this.closeModal();     
      this.spinner = false;  
    }

 

    async deleteNCR(id: number) {
      this.spinner = true;
  
      await this.ncrService.deleteNCR(id).toPromise().then(result => {
          this.toastr.success('', result['message'], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          
      }).catch(err =>{
          this.toastr.error("Please try again.", "There was a problem with deleting the selected report.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).finally(() => {
          this.getNCR(); 
          this.getCar();
        });
      this.modalRef.close();
      this.spinner = false;
    }

    //Create,Update and Cancel functionalities for CAR
    async onSubmitCAR(CAR: any) {
      CAR.fleet_id = this.pushFleetModel;
      CAR.driver_id = this.pushDriverModel;
      CAR.raising_person = this.user.id
      CAR.frmFile = false;
      if(CAR.to_management == true){
        CAR.to_management = 1;
      }
  
      if(CAR.to_operations == true){
        CAR.to_operations = 1;
      }
      if(CAR.to_drivers == true){
        CAR.to_drivers = 1;
      }
  
      if(CAR.to_admin == true){
        CAR.to_admin = 1;
      }
  
      if(CAR.to_others == true){
        CAR.to_others= 1;
      }
      
      if(this.frmFile){
        CAR.frmFile = true;
        await this.uploadFile('ca_report', CAR.supporting_docs);
      }
  
      if(CAR.id){
       await this.updateCAR(CAR);
      }
      else{
          
      this.spinner = true;
      this.CAR = CAR;
      await this.ncrService.createCAR(CAR).toPromise().then(result => {
              this.toastr.success('', result['message'], {
                  timeOut: 5000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                });
              
      }).catch(err =>{
              this.toastr.error("Please try again.", "There was a problem with creating new ncr entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
              });
          }).finally(() => {
              
          });
        }
      this.getCar();  
      this.getNCR();
      this.closeModal();     
      this.spinner = false;  
    }

    async updateCAR(car:Corrective_Action) {
      this.spinner = true;
        await this.ncrService.updateCAR(car).toPromise().then(result=> {
            this.toastr.success('', result['message'], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            }); 
                
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with updating the selected ncr entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).finally(() => {
            
          });
    }

    async cancelCar(id: number) {
      this.spinner = true;

      await this.ncrService.cancelCar(id).toPromise().then(result => {
          this.toastr.success('', result['message'], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          
      }).catch(err =>{
          this.toastr.error("Please try again.", "There was a problem with deleting the selected report.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).finally(() => {
          // this.getNCR(); 
        });
        this.getCar(); 
        this.getNCR(); 
      this.modalRef.close();
      this.spinner = false;
    }

    /*** Export... Module ***/
    //Replaces an attribute name for reading comprehension
    renameKey( obj, oldKey, newKey ) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
      
    }

    //Formats readable header names in the given table

      //Export Excel, CSV and PDF on CAR
    CAR_generateHeaders(list_CAR): any{
        const arr = JSON.parse(list_CAR);
        arr.forEach( obj => {
          this.renameKey( obj, 'category_name', 'Breach Category' );
          this.renameKey( obj, 'codename', 'Breach Code' );
          this.renameKey( obj, 'classification_name', 'Breach Classification' );
          this.renameKey( obj, 'ca_name', 'Corrective Action' );
          this.renameKey( obj, 'ncr_distribution_list', 'Distribution List' );
          this.renameKey( obj, 'raising_person', 'Raising Person' );
          this.renameKey( obj, 'raising_date', 'Raising Date' );
          this.renameKey( obj, 'driver_name', 'Driver' );
          this.renameKey( obj, 'problem_details', 'Breach Details' );
          this.renameKey( obj, 'person_involved_name', 'Person Involved' );
          this.renameKey( obj, 'person_involved_date_signed', 'Person Involved Date Signed');
          this.renameKey( obj, 'close_out_date', 'Closing-out Date' );
          this.renameKey( obj, 'ca_short_term_fix', 'Short Term Fix' );
          this.renameKey( obj, 'ca_short_close_out_person_name', 'Short Term Close Out Person' );
          this.renameKey( obj, 'ca_short_close_out_date', 'Short Term Close Out Date' );
          this.renameKey( obj, 'ca_long_term_fix', 'Long Term Fix' );
          this.renameKey( obj, 'ca_long_close_out_person_name', 'Long Term Close Out Person' );
          this.renameKey( obj, 'ca_long_close_out_date', 'Long Term Close Out Date' );
          this.renameKey( obj, 'approved_name', 'Approved By' );
          this.renameKey( obj, 'approved_date', 'Approved Date' );
        });
        const updatedJson = JSON.stringify( arr );
        return updatedJson;
    }

      //Filters every column in the table list
    CAR_generateColumnsWithFilter(list_CAR){
          const arr = JSON.parse(JSON.stringify(list_CAR));
          arr.forEach( obj => {

            //Format date
            obj['raising_date'] = obj['raising_date'] != null ?  formatDate(obj['raising_date'], 'dd MMM yyyy', 'en_US'): '';
            obj['close_out_date'] = obj['close_out_date'] != null ? formatDate(obj['close_out_date'], 'dd MMM yyyy', 'en_US'): '';
            obj['ca_short_close_out_date'] =obj['ca_short_close_out_date'] != null ? formatDate(obj['ca_short_close_out_date'], 'dd MMM yyyy', 'en_US') : '';
            obj['ca_long_close_out_date'] = obj['ca_long_close_out_date'] ? formatDate(obj['ca_long_close_out_date'], 'dd MMM yyyy', 'en_US') : '';
            obj['approved_date'] = obj['approved_date'] ? formatDate(obj['approved_date'], 'dd MMM yyyy', 'en_US') : '';
            obj['person_involved_date_signed'] = obj['person_involved_date_signed'] ? formatDate(obj['person_involved_date_signed'], 'dd MMM yyyy', 'en_US') : '';

            //remove filtered columns
            if(!this.showFileCAR){
              delete obj['file'];
            };
            if(!this.showCarBreachCategory){
              delete obj['category_name'];
            };
            if(!this.showCarCode){
              delete obj['codename'];
            };
            if(!this.showCarClassification){
              delete obj['classification_name'];
            };
            if(!this.showCorrectiveCAR) {
              delete obj['ca_name'];
            };
            if(!this.showCarProblemDetails){
              delete obj['problem_details'];
            }
            if(!this.showRaisingPerson){
              delete obj['raising_person'];
            };
            if(!this.showRaisingDate){
              delete obj['raising_date'];
            };
            if(!this.showPersonInvolved){
              delete obj['person_involved_name'];
            };
            if(!this.showClosingOutDate){
              delete obj['close_out_date'];
            };
            if(!this.showShortTermFix){
              delete obj['ca_short_term_fix'];
            };
            if(!this.showShortCloseOutPerson){
              delete obj['ca_short_close_out_person_name'];
             
            };
            if(!this.showShortCloseOutDate){
              delete obj['ca_short_close_out_date'];
            };

            if(!this.showLongTermFix){
              delete obj['ca_long_term_fix'];
            };
            if(!this.showLongTermCloseOutPerson){
              delete obj['ca_long_close_out_person_name'];
            };
            if(!this.showLongTermCloseOutDate){
              delete obj['ca_long_close_out_date'];
            };
            if(!this.showManagerSignedDate){
              delete obj['approved_date'];
            };
            if(!this.showApprovedBy){
              delete obj['approved_name'];
            };
            if(!this.showPersonInvolvedDate){
              delete obj['person_involved_date_signed'];
            };
            if(!this.showDistributionList){
              delete obj['ncr_distribution_list'];
            };


            delete obj['id'];
            delete obj['carTaskCount'];
            delete obj['ncr_id']
            delete obj['fleet_id'];
            delete obj['driver_id'];
            delete obj['customer_id'];
            delete obj['file'];
            delete obj['status_name'];
            delete obj['to_management'];
            delete obj['to_admin'];
            delete obj['to_operations'];
            delete obj['to_drivers'];
            delete obj['to_others'];
            delete obj['person_involved_signature'];
            delete obj['breach_category_id'];
            delete obj['code_id'];
            delete obj['ca_id'];
            delete obj['classification_id'];
            delete obj['status_id'];
            delete obj['supporting_docs'];
            delete obj['ca_short_close_out_person'];
            delete obj['ca_long_close_out_person'];
            delete obj['run_control_no'];
            delete obj['approved_by'];
        
          });
          const updatedJson = JSON.stringify( arr );
          return updatedJson;                         
    }

    CAR_exportToCSV(){
        if(this.car_rows.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.CAR_generateColumnsWithFilter(this.car_rows);

            //generate json with format header
            this.formatted_list = this.CAR_generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let csv_file = '[TMS]CAR_' + this.formattedDate(current_date);
            this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS CAR');
        }
    }

    CAR_exportToEXCEL(){
        if(this.car_rows.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.CAR_generateColumnsWithFilter(this.car_rows);

            //generate json with format header
            this.formatted_list = this.CAR_generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let excel_file = '[TMS]CAR_' + this.formattedDate(current_date);
            this.exp_excel.title = 'CAR';
            this.exp_excel.type = 'xlsx';
            this.exp_excel.list_data = this.formatted_list;
            this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
                saveAs(data, excel_file)
            });
        }
    }

    CAR_exportToPDF(){
        if(this.car_rows.length >0){
          let with_header_format, with_column_filter;

          //generate json with filtered column
          with_column_filter = this.CAR_generateColumnsWithFilter(this.car_rows);

          //generate json with format header
          this.formatted_list = this.CAR_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let pdf_file = '[TMS]CAR_' + this.formattedDate(current_date);
          this.exp_pdf.title = 'CAR';
          this.exp_pdf.type = 'pdf';
          this.exp_pdf.list_data = this.formatted_list;
          this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
            saveAs(data, pdf_file + '.' + this.exp_pdf.type);
          });
        }
    }

  //Export Excel, CSV and PDF on NCR
    generateHeaders(list_NCR): any{
      const arr = JSON.parse(list_NCR);
      arr.forEach( obj => {
        this.renameKey( obj, 'control_no', 'Control No.');
        this.renameKey( obj, 'category_name', 'Breach Category');
        this.renameKey( obj, 'codename', 'Breach Code');
        this.renameKey( obj, 'classification_name', 'Classification');
        this.renameKey( obj, 'status_name', 'Status');
        this.renameKey( obj, 'driver_name', 'Driver');
        this.renameKey( obj, 'run_control_no', 'Manifest Control No');
        this.renameKey( obj, 'created_by', 'Created By');
        this.renameKey( obj, 'problem_details', 'Problem Details');
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;
    }

  //Filters every column in the table list
    NCR_generateColumnsWithFilter(list_NCR){
      const arr = JSON.parse(JSON.stringify(list_NCR));
      arr.forEach( obj => {

        //remove filtered columns

        if(!this.showBreachCategory){
          delete obj['category_name'];
        };
        if(!this.showCode){
          delete obj['codename'];
        };
        if(!this.showClassification){
          delete obj['classification_name'];
        };
        if(!this.showStatus){
          delete obj['status_name'];
        };
        if(!this.showFile){
          delete obj['file'];
        };

        if(!this.showProblemDetails) {
          delete obj['problem_details'];
        }

        delete obj['id'];
        delete obj['fleet_id'];
        delete obj['fleet'];
        delete obj['driver_id'];
        delete obj['customer_id'];
        delete obj['file'];
        delete obj['category_id'];
        delete obj['code_id'];
        delete obj['status_id'];
        delete obj['classification_id'];
        delete obj['supporting_docs'];
        
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
    }

    NCR_exportToCSV(){
        if(this.ncr_rows.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.NCR_generateColumnsWithFilter(this.ncr_rows);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let csv_file = '[TMS]Quality Assurance Report' + this.formattedDate(current_date);
            this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Quality Assurance Report');
        }
    }

    NCR_exportToPDF(){
      if(this.ncr_rows.length >0){
        let with_header_format, with_column_filter;

        //generate json with filtered column
        with_column_filter = this.NCR_generateColumnsWithFilter(this.ncr_rows);

        //generate json with format header
        this.formatted_list = this.generateHeaders(with_column_filter);

        //export to file
        let current_date = new Date();
        let pdf_file = '[TMS]Quality Assurance Report_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'Quality Assurance Report';
        this.exp_pdf.type = 'pdf';
        this.exp_pdf.list_data = this.formatted_list;
        this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
          saveAs(data, pdf_file + '.' + this.exp_pdf.type);
        });
      }
    }
      
    //Exports table to MS Excel file
    NCR_exportToEXCEL(){
        if(this.ncr_rows.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.NCR_generateColumnsWithFilter(this.ncr_rows);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let excel_file = '[TMS]Quality Assurance Report_' + this.formattedDate(current_date);
            this.exp_excel.title = 'Quality Assurance Report';
            this.exp_excel.type = 'xlsx';
            this.exp_excel.list_data = this.formatted_list;
            this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
                saveAs(data, excel_file)
            });
        }
    }

    //Filter for NCR
    updateFilter(){
      this.isFilterEmpty = false;
      this.ncr_rows = this.fullRows;
      this.temp = this.fullRows;

      if (this.filterBreachCategory) {
        this.temp = this.temp.filter(data => {
          if (data.category_name && this.filterBreachCategory) {
            return data.category_name.toLowerCase().indexOf(this.filterBreachCategory.toLowerCase()) !== -1 || !this.filterBreachCategory.toLowerCase();
          } else {
            return data.category_name
          };
        });
      }

      if (this.filterBreachCode) {
        this.temp = this.temp.filter(data => {
          if (data.codename && this.filterBreachCode) {
            return data.codename.toLowerCase().indexOf(this.filterBreachCode.toLowerCase()) !== -1 || !this.filterBreachCode.toLowerCase();
          } else {
            return data.codename
          };
        });
      }

      if (this.filterBreachClass) {
        this.temp = this.temp.filter(data => {
          if (data.classification_name && this.filterBreachClass) {
            return data.classification_name.toLowerCase().indexOf(this.filterBreachClass.toLowerCase()) !== -1 || !this.filterBreachClass.toLowerCase();
          } else {
            return data.classification_name
          };
        });
      }

      if (this.filterNcrDriver) {
        this.temp = this.temp.filter(data => {
          if (data.driver_name && this.filterNcrDriver) {
            return data.driver_name.toLowerCase().indexOf(this.filterNcrDriver.toLowerCase()) !== -1 || !this.filterNcrDriver.toLowerCase();
          } else {
            return data.driver_name
          };
        });
      }

      if (this.filterStatus && this.filterStatus.length) {
        this.temp = this.temp.filter(data => { 
          if (data.status_name && data.status_name.length)
            return data.status_name.toLowerCase().indexOf(this.filterStatus.toLowerCase() ) !== -1 || !this.filterStatus.toLowerCase();   
          else return data.status_name;   
        });
      }

      this.ncrCount = Object.keys(this.ncr_rows).length;    
      this.ncr_rows = this.temp;

      if (this.ncr_rows.length > 0) {
        this.selected = [this.ncr_rows[0]]
      } else {
        this.selected = [];
      }

    }

    onClickStatus(status) {
      this.filterStatus = status;
      this.updateFilter();
    }

    //Filter for CAR
    updateCARFilter() {
      this.isFilterEmpty = false;
      this.car_rows = this.fullCarRows;
      this.temp = this.fullCarRows;
    
      if (this.filterCorrectiveAction) {
        this.temp = this.temp.filter(data => {     
          if (data.ca_name && this.filterCorrectiveAction) {
            return data.ca_name.toLowerCase().indexOf(this.filterCorrectiveAction.toLowerCase()) !== -1 || !this.filterCorrectiveAction.toLowerCase();
          } else {
            return data.ca_name
          };
        });
      }
    
      if (this.filterRaisingPerson) {
        this.temp = this.temp.filter(data => {
          if (data.raising_person && this.filterRaisingPerson) {
            return data.raising_person.toLowerCase().indexOf(this.filterRaisingPerson.toLowerCase()) !== -1 || !this.filterRaisingPerson.toLowerCase();
          } else {
            return data.raising_person
          };
        });
      }
    
      if (this.filterPersonInvolved) {
        this.temp = this.temp.filter(data => {
          if (data.person_involved_name && this.filterPersonInvolved) {
            return data.person_involved_name.toLowerCase().indexOf(this.filterPersonInvolved.toLowerCase()) !== -1 || !this.filterPersonInvolved.toLowerCase();
          } else {
            return data.person_involved_name
          };
        });
      }
    
      if (this.filterShortFix) {
        this.temp = this.temp.filter(data => {
          if (data.ca_short_term_fix && this.filterShortFix) {
            return data.ca_short_term_fix.toLowerCase().indexOf(this.filterShortFix.toLowerCase()) !== -1 || !this.filterShortFix.toLowerCase();
          } else {
            return data.ca_short_term_fix
          };
        });
      }

      if (this.filterCarDriver) {
        this.temp = this.temp.filter(data => {
          if (data.driver_name && this.filterCarDriver) {
            return data.driver_name.toLowerCase().indexOf(this.filterCarDriver.toLowerCase()) !== -1 || !this.filterCarDriver.toLowerCase();
          } else {
            return data.driver_name
          };
        });
      }
    
      if (this.filterLongFix) {
        this.temp = this.temp.filter(data => {
          if (data.ca_long_term_fix && this.filterLongFix) {
            return data.ca_long_term_fix.toLowerCase().indexOf(this.filterLongFix.toLowerCase()) !== -1 || !this.filterLongFix.toLowerCase();
          } else {
            return data.ca_long_term_fix
          };
        });
      }
    
    
      if (this.filterStatus && this.filterStatus.length) {
        this.temp = this.temp.filter(data => { 
          if (data.status_name && data.status_name.length)
            return data.status_name.toLowerCase().indexOf(this.filterStatus.toLowerCase() ) !== -1 || !this.filterStatus.toLowerCase();   
          else return data.status_name;   
        });
      }
    
      this.carCount = Object.keys(this.car_rows).length;    
      this.car_rows = this.temp;
    
        if (this.car_rows.length > 0) {
          this.selected = [this.car_rows[0]]
        } else {
          this.selected = [];
        }
    
    }

    onClickCARStatus(status) {
      this.filterStatus = status;
      this.updateCARFilter();
    }

    
    public resetFilters(){
      this.filterBreachStat = '';
      this.filterBreachCategory = '';
      this.filterBreachCode = '';
      this.filterBreachClass = '';
      this.filterNcrDriver = '';
      this.ncrCount = Object.keys(this.ncr_rows).length;

      this.ncr_rows = this.fullRows;
      this.ncrCount = Object.keys(this.ncr_rows).length;
      this.isFilterEmpty = true;
    }

    public resetCARFilters(){
      this.filterCorrectiveAction = '';
      this.filterRaisingPerson = '';
      this.filterPersonInvolved = '';
      this.filterShortFix = '';
      this.filterLongFix = '';
      this.filterCarDriver = '';
      this.carCount = Object.keys(this.car_rows).length;
  
      this.car_rows = this.fullCarRows;
      this.carCount = Object.keys(this.car_rows).length;
      this.isFilterEmpty = true;
    } 

    public processURLFilter(field_filter: string, key_filter:string){
      if (field_filter == 'status') {
        if (key_filter == '1') {
          this.filterStatus = 'Pending'
        }
        if (key_filter == '2') {
          this.filterStatus = 'Processing'
        }
        if (key_filter == '3') {
          this.filterStatus = 'Resolved'
        }
        if (key_filter == '4') {
          this.filterStatus = 'Terminated'
        }
        if (key_filter == '5') {
          this.filterStatus = 'Cancelled'
        }
      }
      this.updateFilter();
      this.updateCARFilter();
    }


    // Uploading, Updatating and Deleting FILE
    async uploadFile(caller, filename){
      if (this.frmFile){
       await this.fileService.uploadRawFile(caller, this.frmFile, filename).toPromise();
      }
      this.frmFile = '';

      //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(caller, this.oldFile);
        };
    }

    public deleteFile(caller, filename){
      this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;
    }

    public resetFileVariables(){
      // for document file handling variables; checking if file exists or removed
        this.fileExists = false;
        this.fileRemove  = false;
        this.oldFile = '';
    }

    public removeFile(caller){
      this.fileExists  = false;
      switch (caller){
          case this.prefixNCR:
            {
              this.NCRForm.controls.supporting_docs.setValue(''); break;
            };
          case this.prefixCAR:
            {
              this.CARForm.controls.supporting_docs.setValue(''); break;
            };
          default: break;
          }
          
          this.fileRemove = true;
    }

    public getFile(event, caller){

      var imgFilename;
  
      if (event == '' || event == null){
        imgFilename = event;
        this.is_image = true;
      }else{
        var str = event.file.type.split("/");
        var a = str[str.length -1];
        if(a.toLowerCase() == 'png' || a.toLowerCase() == 'jpg' || a.toLowerCase() == 'jpeg' || a.toLowerCase() == 'pdf'){
              var file : ImageResult;
              file = event;
              imgFilename =  file.file.name;
              this.frmFile = event;
              this.is_image = true;
        }
        else{
              this.toastr.error('', 'File should be an image or pdf', {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
              imgFilename = null;
              this.is_image = false;
        }
      }

  
      switch (caller){
        case this.prefixNCR: 
          { 
            this.NCRForm.controls.supporting_docs.setValue(imgFilename); break;
          };
          case this.prefixCAR: 
          { 
            this.CARForm.controls.supporting_docs.setValue(imgFilename); break;
          };
        default: break;
      }
    
    }

    
  //Print Functionality
    print1(): void {
      let printContents, popupWin;
      printContents = document.getElementById('print-section1').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Quality Assurance Report</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
              
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }


    //Print Functionality
    print2(): void {
      let printContents, popupWin;
      printContents = document.getElementById('print-section2').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Corrective Action Report </title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
              
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }

    //TASK MODAL
    public action: string;
    openPromptModalTask(modalName, task:Task, objectId) { 

      if(task){
        this.action = 'Edit';
        this.task_title = task.title
      }else{
        this.action = 'Add';  
      };
  
      this.task = task;
      this.carId = objectId
  
      this.modalRef = this.modal.open(modalName, { size: 'lg', backdrop:'static'});
    }  

    public closeModalTask(){
      this.getCar();
      this.getTasksByCarId();
      this.closeModal();
    }

    public getTasksByCarId() {
      if (this.selected4.length>0) {
        this.taskService.getTasksByCarId(this.selected4[0].id).subscribe(result => {
          this.tasksByCarId = result['tasks'];
          
        })
      }
    }

    onSelect2({ selected2 }) {
      console.log('Select Event2', selected2, this.selected4);
      this.getTasksByCarId();
    }
  
    onActivate2(event) {
      console.log('Activate Event2', event);
    }

    deleteTask(taskId : number){
      this.spinner = true;
      this.taskService.deleteTask(taskId).subscribe(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }, ()=>{
        this.toastr.error("Please try again.", "There was a problem with deleting the selected task.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
    });
  
      this.closeModalTask();
      this.spinner = false;
      this.task = null;
    }

    openMarkCompleteModal(modalMarkCompleted): void { 
      this.modalRef = this.modal.open(modalMarkCompleted, { container: '.app' , size: 'sm', backdrop: 'static'});
    }  

    public formatDate(inDate: string) {
      let formatedDate: Date;
      formatedDate = new Date(inDate.replace(/-/g, "/"));
      return formatedDate;
    }

    markCompleted(objectId){

    //mark all task completed
    this.spinner = true;
   
      this.taskService.updateAllTaskCompletedByCarId(objectId).subscribe(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }, ()=>{
        this.toastr.error("Please try again.", "There was a problem with updating the tasks completed by the selected corrective action entry.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });

      this.getTasksByCarId();
      this.getCar();
      this.getNCR();
      this.closeModal();
      this.spinner = false;
    } 

    isEnabled(name){
      let is_enabled = false;
      is_enabled = this.svc_components.isComponentEnabled(name);
      return is_enabled
    }

}
